import Component from "../../../lib/component";
import Tracker from "../../../lib/tracker";
import {getTrackerOptions} from "../../../lib/tracker_helpers";

export const EnquireOptionConfig = {
    componentTypeKey: 'EnquireOption',
    baseHtmlClass: 'enquire_option',
    selector: '.enquire_option',
    datasetConfigKey: 'enquire_option__config',

    selectedEventNameDatasetConfigKey: 'selected_event_name',
    analyticsParametersDatasetConfigKey: 'analytics_parameters',
    trackerOptionsDatasetConfigKey: 'tracker_options',

    linkSelector: 'a',
};

export class EnquireOption extends Component {

    static get config() {
        return EnquireOptionConfig;
    }

    constructor(id_or_element, config) {
        super({
            element: id_or_element,
            config: EnquireOptionConfig
        });

        this.setDatasetConfig(EnquireOptionConfig.datasetConfigKey);

        this.selectedEventName = this.getDatasetConfigValue(EnquireOptionConfig.selectedEventNameDatasetConfigKey);
        this.analyticsParameters = this.getAnalyticsParameters();
        this.trackerOptions = getTrackerOptions(this.getDatasetConfigValue(EnquireOptionConfig.trackerOptionsDatasetConfigKey));

        this.tracker = new Tracker(window, document, this.trackerOptions);

        this.selected = false;

        this.linkElement = this.element.querySelector(EnquireOptionConfig.linkSelector);
        this.linkElement.addEventListener('click', this.handleLinkClick.bind(this));

        this.render();
    }

    handleLinkClick() {
        this.selected = true;
        this.trackSelectedEvent();
        this.render();
    }

    trackSelectedEvent() {
        if (!this.tracker || !this.tracker.eventTracker) return;
        if (!this.selectedEventName) return;
        this.tracker.eventTracker(this.selectedEventName, this.analyticsParameters);
    }

    render() {
        this.conditionallySetHtmlClassState(this.isSelected(), 'selected');
    }

    isSelected() {
        return !!this.selected;
    }

    getAnalyticsParameters() {
        const parameters = this.getDatasetConfigValue(EnquireOptionConfig.analyticsParametersDatasetConfigKey);
        if (!parameters) return;
        return parameters;
    }

}